import { createFileRoute } from '@tanstack/react-router';
import ImportingPage from '@/pages/workspaces/journeys/collections/[collectionId]/importing.page';
import { LazyPage } from './-route-layouts';

function CollectionImportingRoute() {
  return (
    <LazyPage>
      <ImportingPage />
    </LazyPage>
  );
}

export const Route = createFileRoute(
  '/_authenticated/workspaces/$workspaceId/journeys/collections/$collectionId/importing',
)({
  component: CollectionImportingRoute,
});
